import React, { Component } from 'react';
import { Box, Container } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../Pages/styles/YouTubeShortsSlider.css'
import YouTubeShortEmbed from './YouTubeShortEmbed';

class YouTubeShortsSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
      swiper: null,
      isVisible: false
    };
    this.sliderRef = React.createRef();
  }

  componentDidMount() {
    if (this.state.swiper) {
      this.handleSlideChange(this.state.swiper);
    }
    this.observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        this.setState({ isVisible: entry.isIntersecting });
      },
      {
        threshold: 0.5 
      }
    );

    if (this.sliderRef.current) {
      this.observer.observe(this.sliderRef.current);
    }
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  handleSlideChange = (swiper) => {
    if (!swiper) return;
    const realIndex = swiper.realIndex;
    
    this.setState({ 
      activeIndex: realIndex,
      swiper: swiper 
    });
  };
  handleNextSlide = () => {
    const { swiper } = this.state;
  
    if (swiper && swiper.slideNext) {
      let isSwiped = swiper.slideNext(); // Slide to next with animation
      if(!isSwiped)swiper.slidePrev();
    } 
  };
  
  handlePrevSlide = () => {
    const { swiper } = this.state;
    if (swiper && swiper.slidePrev) {
      swiper.slidePrev();
    }
  };
  
  render() {
    const { shortIds } = this.props;
    const { isVisible } = this.state;

    return (
      <Container maxWidth="md" className='shorts-slider-container' ref={this.sliderRef}>
        <Box sx={{ 
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
          <Box sx={{ width: '100%', position: 'relative' }}>
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              autoplay={false}
              allowTouchMove={false}
              touchStartPreventDefault={false}
              touchMoveStopPropagation={false}
              breakpoints={{
                0: {
                  slidesPerView: "auto",
                  centeredSlides: true,
                  initialSlide: 0,
                },
                768: {
                  slidesPerView: 3,
                  centeredSlides: true,
                  initialSlide: 0,
                  spaceBetween: 25,
                  centeredSlidesBounds:true,
                }
              }}
              loop={true}
              speed={400}
              touchRatio={1}
              touchAngle={45}
              resistance={false}
              followFinger={true}
              threshold={0}
              pagination={{ 
                clickable: true,
                dynamicBullets: true, 
              }}
              // navigation={{
              //   nextEl: '.swiper-button-next',
              //   prevEl: '.swiper-button-prev',
              // }}
              onSlideChange={this.handleSlideChange}
              onSwiper={(swiper) => {
                this.setState({ swiper });
                this.handleSlideChange(swiper);
              }}
              className="mui-youtube-slider"
            >
              {shortIds.map((video, index) => (
                <SwiperSlide 
                  key={`${video}-${index}`}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    width: '200px',
                  }}
                >
                  <Box sx={{
                    width: '180px',
                    height: '320px',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                  }}>
                    <YouTubeShortEmbed
                    key={`${video}-${index}`}
                      videoId={video}
                      index={index}
                      isActive={this.state.activeIndex === index && isVisible}
                    />
                  </Box>
                </SwiperSlide>
              ))}
            </Swiper>

            <Box sx={{
              position: 'absolute',
              top: '50%',
              left: 0,
              right: 0,
              transform: 'translateY(-50%)',
              zIndex: 1000,
              display: 'flex',
              justifyContent: 'space-between',
              // pointerEvents: 'none',
            }}>
              <Box
                className="swiper-button-prev"
                sx={{ pointerEvents: 'auto', cursor: 'pointer' }}
                onClick={this.handlePrevSlide}
              />
              <Box
                className="swiper-button-next"
                sx={{ pointerEvents: 'auto', cursor: 'pointer' }}
                onClick={this.handleNextSlide}
              />
            </Box>
          </Box>
        </Box>
      </Container>
    );
  }
}

export default YouTubeShortsSlider;
